export const LinkButton = ({ link = "", children, className, ...props }) => {
  return (
    <a className={`w-full text-inherit glass-button flex flex-row items-center ${className}`} href={link} {...props}>
      {children}
    </a>
  );
};

